
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo-quiz",
      function () {
        return require("private-next-pages/demo-quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo-quiz"])
      });
    }
  